












































import { Component, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { ElForm } from 'element-ui/types/form';
import { CollectionForm } from '@service/solr/collections';

const Store = namespace('management/collections');

@Component
export default class NewCollectionForm extends Vue {
  private creatingCollection = false;

  @Store.State private configSets!: string[];
  @Store.State private loadingConfigSets!: boolean;
  @Store.State private newCollectionFormData!: CollectionForm;

  @Store.Action private loadConfigSets!: () => void;

  created() {
    this.loadConfigSets();
  }

  private get numShardsRequired(): boolean {
    return this.newCollectionFormData && this.newCollectionFormData['router.name'] === 'compositeId';
  }

  private get validateRules() {
    return {
      name: [
        {
          required: true,
          message: 'Collection name is required',
          trigger: 'change',
        },
      ],
      numShards: [
        {
          required: this.numShardsRequired,
          type: 'number',
          message: 'numShards is required when router.name is compositeId.',
          trigger: 'change',
        },
      ],
    };
  }

  private submitForm() {
    (this.$refs.newCollectionForm as ElForm).validate((valid) => {
      if (!valid) {
        return;
      }
      if (this.creatingCollection) return;
      this.creatingCollection = true;
      this.$service.solr.collections.create(this.newCollectionFormData).then(
        () => {
          this.creatingCollection = false;
          this.$emit('done');
        },
        () => {
          this.creatingCollection = false;
        },
      );
    });
  }
}
